const INITIAL_STATE = {
    funcionario: {},
    funcionarios: [],
    loading: false,
    processing: false,
}

export default function Funcionario(state = INITIAL_STATE, action) {
    switch(action.type) {
        case 'FUNCIONARIO_PROCESSING' :
            return { ...state, processing: action.payload };
        case 'FUNCIONARIO_LOADING' :
            return { ...state, loading: action.payload };
        case 'FUNCIONARIO_FETCHED' :
            return { ...state, funcionario: action.payload };
        case 'FUNCIONARIOS_FETCHED' :
            return { ...state, funcionarios: action.payload };
        default :
            return state
    }
}